/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.knowledge.base.agent.rpc.SuggestionsFeedbackRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getSuggestionsFeedbackByArticleIdRpc = {
  serviceName: 'com.hubspot.knowledge.base.agent.rpc.SuggestionsFeedbackRpc',
  rpcName: 'getSuggestionsFeedbackByArticleId',
  auth: 'app',
  fingerprint: 'm5U5EZqnjT_RbeWCYIEeqRnBiAQTwlky',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createSuggestionsFeedbackRpc = {
  serviceName: 'com.hubspot.knowledge.base.agent.rpc.SuggestionsFeedbackRpc',
  rpcName: 'createSuggestionsFeedback',
  auth: 'app',
  fingerprint: 'Rn6nJfnZ6yOgrM-hNOj0LRnBiAQTwlky',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteSuggestionsFeedbackRpc = {
  serviceName: 'com.hubspot.knowledge.base.agent.rpc.SuggestionsFeedbackRpc',
  rpcName: 'deleteSuggestionsFeedback',
  auth: 'app',
  fingerprint: 'BBpjqBBqLeqQOJDcXljE75wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};